import styled, { keyframes } from 'styled-components';

const revealCategory = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Section = styled.section`
  width: 100%;

  padding: var(--space-xxxxl) 0;

  /* background: var(--offWhite); */

  scroll-margin-top: 100px;

  @media screen and (max-width: 950px) {
    padding: var(--space-xxxl) 0;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) 0;
  }
`;

export const Container = styled.div`
  width: min(100%, 1280px);

  margin: 0 auto;
`;

export const SectionHeader = styled.div`
  max-width: 820px;

  margin-bottom: var(--space-xxxl);

  @media screen and (max-width: 800px) {
    margin-bottom: var(--space-xxl);
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 var(--space-xs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.78rem;
  font-weight: 850;

  text-transform: uppercase;
  letter-spacing: 0.14em;
`;

export const Title = styled.h2`
  max-width: 790px;

  margin: 0;

  color: var(--grey7);

  font-size: 58px;
  line-height: 1.03;
  font-weight: 800;

  letter-spacing: -0.04em;

  @media screen and (max-width: 600px) {
    /* font-size: clamp(2rem, 11vw, 3rem); */
    font-size: clamp(1.9rem, 8vw, 2.8rem);
  }
`;

export const Description = styled.p`
  max-width: 700px;

  margin: var(--space-m) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 1rem;
  line-height: 1.8;
  font-weight: 500;

  @media screen and (max-width: 600px) {
    font-size: 0.95rem;
    line-height: 1.7;
  }
`;

export const MobileNavigation = styled.div`
  display: none;

  @media screen and (max-width: 850px) {
    display: grid;
    gap: var(--space-xs);

    margin-bottom: var(--space-xl);
  }
`;

export const MobileNavigationLabel = styled.label`
  color: var(--grey6);

  font-family: var(--mainFont);
  font-size: 0.84rem;
  font-weight: 800;
`;

export const MobileSelect = styled.select`
  width: 100%;
  min-height: 52px;

  padding: 0.8rem 2.8rem 0.8rem 1rem;

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadius);

  background: var(--white);
  color: var(--grey7);

  box-shadow: var(--shadow-xs);

  font-family: var(--mainFont);
  font-size: 0.95rem;
  font-weight: 700;

  cursor: pointer;

  &:focus-visible {
    border-color: var(--orange5);

    outline: 3px solid var(--yellow3);
    outline-offset: 3px;
  }
`;

export const ProductsLayout = styled.div`
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr);
  gap: var(--space-xxxl);
  align-items: start;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 220px minmax(0, 1fr);
    gap: var(--space-xl);
  }

  @media screen and (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

export const Sidebar = styled.aside`
  position: sticky;
  top: 110px;

  overflow: hidden;

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadius);

  background: var(--white);

  box-shadow: var(--shadow-xs);

  @media screen and (max-width: 850px) {
    display: none;
  }
`;

export const SidebarHeader = styled.div`
  padding: var(--space-l);

  border-bottom: 1px solid var(--grey1);
`;

export const SidebarTitle = styled.h3`
  margin: 0;

  color: var(--grey7);

  font-size: 1rem;
  line-height: 1.3;
  font-weight: 800;
`;

export const CategoryNavigation = styled.nav`
  display: grid;
  gap: var(--space-xxs);

  padding: var(--space-xs);
`;

export const CategoryNavButton = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  gap: var(--space-s);

  padding: 0.8rem var(--space-m);

  border: 0;
  border-radius: var(--borderRadiusSmall);

  background: ${({ $active }) => ($active ? 'var(--yellow1)' : 'transparent')};

  color: ${({ $active }) => ($active ? 'var(--grey7)' : 'var(--grey4)')};

  font-family: var(--mainFont);
  font-size: 0.88rem;
  font-weight: ${({ $active }) => ($active ? '800' : '700')};
  text-align: left;

  cursor: pointer;

  transition:
    background-color 160ms ease,
    color 160ms ease;

  &:hover {
    background: ${({ $active }) =>
      $active ? 'var(--yellow1)' : 'var(--grey15)'};

    color: var(--grey7);
  }

  &:focus-visible {
    outline: 3px solid var(--yellow3);
    outline-offset: 1px;
  }
`;

export const CategoryNavIcon = styled.span`
  width: 32px;
  height: 32px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border: 1px solid rgba(230, 139, 7, 0.14);
  border-radius: 50%;

  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);

  color: var(--orange5);

  font-size: 0.9rem;

  svg {
    display: block;
  }
`;

export const SidebarCallout = styled.div`
  padding: var(--space-l);

  border-top: 1px solid var(--grey1);

  background: rgba(255, 240, 194, 0.4);
`;

export const SidebarCalloutTitle = styled.h4`
  margin: 0;

  color: var(--grey7);

  font-size: 1rem;
  line-height: 1.25;
  font-weight: 800;
`;

export const SidebarCalloutText = styled.p`
  margin: var(--space-xs) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.8rem;
  line-height: 1.55;
  font-weight: 500;
`;

export const SidebarCalloutLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  margin-top: var(--space-m);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.8rem;
  font-weight: 800;
  text-decoration: none;

  svg {
    flex-shrink: 0;

    transition: transform 160ms ease;
  }

  &:hover {
    color: var(--orange5);

    svg {
      transform: translateX(3px);
    }
  }

  &:focus-visible {
    border-radius: 3px;

    outline: 3px solid var(--yellow4);
    outline-offset: 4px;
  }
`;

export const ProductsContent = styled.div`
  min-width: 0;

  display: grid;
  gap: var(--space-xl);
`;

export const CategoryPanel = styled.article`
  min-width: 0;

  padding: var(--space-xxl);

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadius);

  background: var(--white);

  box-shadow: var(--shadow-xs);

  animation: ${revealCategory} 220ms ease both;

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
  }
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-l);

  padding-bottom: var(--space-xl);

  border-bottom: 1px solid var(--grey1);

  @media screen and (max-width: 560px) {
    flex-direction: column;
    gap: var(--space-m);
  }
`;

export const CategoryIcon = styled.div`
  width: 58px;
  height: 58px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  padding: var(--space-s);

  border: 1px solid rgba(230, 139, 7, 0.14);
  border-radius: 50%;

  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);

  color: var(--orange5);

  font-size: 1.4rem;

  svg {
    display: block;
  }
`;

export const CategoryHeadingGroup = styled.div`
  min-width: 0;
  max-width: 680px;
`;

export const CategoryEyebrow = styled.p`
  margin: 0 0 var(--space-xs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.72rem;
  font-weight: 850;

  text-transform: uppercase;
  letter-spacing: 0.13em;
`;

export const CategoryTitle = styled.h3`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1.8rem, 3vw, 2.6rem);
  line-height: 1.05;
  font-weight: 800;

  letter-spacing: -0.03em;
`;

export const CategoryDescription = styled.p`
  max-width: 650px;

  margin: var(--space-s) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.95rem;
  line-height: 1.7;
  font-weight: 500;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;

  margin-top: var(--space-xl);

  @media screen and (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductGroup = styled.div`
  min-width: 0;

  padding: 0 var(--space-l);

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  &:not(:last-child) {
    border-right: 1px solid var(--grey1);
  }

  @media screen and (max-width: 1100px) {
    padding: var(--space-l) 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    &:not(:last-child) {
      border-right: 0;
      border-bottom: 1px solid var(--grey1);
    }
  }
`;

export const ProductGroupTitle = styled.h4`
  margin: 0;

  color: var(--grey7);

  font-size: 1rem;
  line-height: 1.35;
  font-weight: 800;
`;

export const ProductList = styled.ul`
  display: grid;
  gap: var(--space-s);

  margin: var(--space-l) 0 0;
  padding: 0;

  list-style: none;
`;

export const ProductListItem = styled.li`
  min-width: 0;

  display: flex;
  align-items: flex-start;
  gap: var(--space-xs);

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.86rem;
  line-height: 1.55;
  font-weight: 500;
`;

export const CheckIcon = styled.span`
  flex-shrink: 0;

  display: grid;
  place-items: center;

  margin-top: 0.13rem;

  color: var(--successGreen);

  font-size: 1rem;

  svg {
    display: block;
  }
`;

export const CategoryFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-l);

  margin-top: var(--space-xl);
  padding-top: var(--space-l);

  border-top: 1px solid var(--grey1);

  @media screen and (max-width: 700px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const CategoryNote = styled.p`
  max-width: 560px;

  margin: 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.85rem;
  line-height: 1.6;
  font-weight: 500;
`;

export const CategoryButton = styled.a`
  min-height: 46px;

  flex-shrink: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  padding: 0.85rem 1.2rem;

  border: 1px solid var(--grey7);
  border-radius: var(--borderRadiusButton);

  background: var(--grey7);
  color: var(--white);

  box-shadow: var(--shadow-xs);

  font-family: var(--mainFont);
  font-size: 0.86rem;
  line-height: 1;
  font-weight: 800;
  text-decoration: none;

  transition:
    transform 160ms ease,
    background-color 160ms ease,
    border-color 160ms ease,
    box-shadow 160ms ease;

  &:hover {
    transform: translateY(-2px);

    border-color: var(--orange5);

    background: var(--orange5);

    box-shadow: var(--shadow-sm);
  }

  &:focus-visible {
    outline: 3px solid var(--yellow3);
    outline-offset: 4px;
  }

  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const ButtonIcon = styled.span`
  flex-shrink: 0;

  display: grid;
  place-items: center;

  transition: transform 160ms ease;

  svg {
    display: block;
  }

  ${CategoryButton}:hover & {
    transform: translateX(3px);
  }
`;

export const AdditionalProducts = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-l);

  padding: var(--space-xl);

  border: 1px solid rgba(230, 139, 7, 0.18);
  border-radius: var(--borderRadius);

  background: rgba(255, 240, 194, 0.42);

  @media screen and (max-width: 600px) {
    flex-direction: column;

    padding: var(--space-l);
  }
`;

export const AdditionalIcon = styled.div`
  width: 48px;
  height: 48px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border: 1px solid rgba(230, 139, 7, 0.14);
  border-radius: 50%;

  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);

  color: var(--orange5);

  font-size: 1.2rem;

  svg {
    display: block;
  }
`;

export const AdditionalContent = styled.div`
  max-width: 720px;
`;

export const AdditionalTitle = styled.h3`
  margin: 0;

  color: var(--grey7);

  font-size: 1.35rem;
  line-height: 1.2;
  font-weight: 800;

  letter-spacing: -0.02em;
`;

export const AdditionalText = styled.p`
  margin: var(--space-s) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  line-height: 1.7;
  font-weight: 500;
`;

export const AdditionalLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  margin-top: var(--space-m);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.85rem;
  font-weight: 800;
  text-decoration: none;

  svg {
    flex-shrink: 0;

    transition: transform 160ms ease;
  }

  &:hover {
    color: var(--orange5);

    svg {
      transform: translateX(3px);
    }
  }

  &:focus-visible {
    border-radius: 3px;

    outline: 3px solid var(--yellow4);
    outline-offset: 4px;
  }
`;
